<header class="header">
  <div class="header__layout">
    <div class="header__dropdown dashboard-menu" (click)="openDashboardMenu()" appClickOutside (clickOutside)="clickedOutsideDashboardMenu()">
      <img
        [src]="(companyService.companyInfo$ | async)?.logoUrl ?? './assets/images/workflow.svg'"
        [alt]="(companyService.companyInfo$ | async)?.name ?? 'WorkFlow'" />

      <div class="header__dropdown-menu" [ngClass]="{ active: isDashboardMenuOpen }">
        <span class="icon-arrow icon-Arrow-Down"></span>
        <ul [ngClass]="{ visible: isDashboardMenuOpen }">
          <li routerLink="/dashboard" class="company-dashboard">
            <span class="icon icon-Dashboard"></span>
            {{ 'dashboard.title' | translate }}
          </li>
          <li *ngIf="(userService.userCompanyList$ | async) && (userService.userCompanyList$ | async)!.length > 0" class="company-list-title">
            {{ 'dashboard.your_companies' | translate }}
          </li>
          <li
            *ngFor="let company of userService.userCompanyList$ | async"
            [ngClass]="{ active: authService.getCurrentCompanyId() == company.id.toString() }">
            <a class="link" href="/workspace/{{company.id}}">
              <img [src]="company.logoUrl ? company.logoUrl : './assets/images/company-default.png'" [alt]="company.name" />
              <span class="name">{{ company.name }}</span>
              <span *ngIf="authService.getCurrentCompanyId() == company.id.toString()" class="checked icon-Checked"></span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="header__menu" *ngIf="isMainMenuVisible && (this.companyService.companyInfo$ | async) as company">
      <a routerLink="/workspace/{{company.id}}/employees" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">{{ 'header.employees' | translate }}</a>
      <a routerLink="/workspace/{{company.id}}/posts" routerLinkActive="active"
        >{{ 'header.news' | translate }}
        <span *ngIf="(postsService.unreadPostsCount$ | async) || 0 > 0" class="indicator"> <span class="indicator-dot unread"></span></span
      ></a>
      <a routerLink="/workspace/{{company.id}}/calendar" routerLinkActive="active">{{ 'header.calendar' | translate }}</a>
      <a routerLink="/workspace/{{company.id}}/devices" routerLinkActive="active">{{ 'header.devices' | translate }}</a>
      <a routerLink="/company/{{company.id}}" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">{{ 'header.company' | translate }}</a>
    </div>
    <div class="header__dropdown profile-menu" (click)="openProfileMenu()" appClickOutside (clickOutside)="clickedOutsideProfileMenu()">
      <div class="current-user" *ngIf="userService.userInfo$ | async as userInfo">
        <h3>{{ userInfo.firstName }} {{ userInfo.lastName }}</h3>
        <p>{{ userInfo.email }}</p>
      </div>
      <div class="header__dropdown-menu" [ngClass]="{ active: isProfileMenuOpen }">
        <span class="icon-arrow icon-Arrow-Down"></span>
        <ul [ngClass]="{ visible: isProfileMenuOpen }">
          <li *ngIf="(userService.profileInfo$ | async)?.id" (click)="openEmployeeModal()">
            <span class="name">{{ 'dashboard.profile_in' | translate }} {{ (companyService.companyInfo$ | async)?.name }}</span>
            <span class="icon icon-Profile"></span>
          </li>
          <li routerLink="/user-profile">
            {{ 'header.account' | translate }}
            <span class="icon icon-User"></span>
          </li>
          <li (click)="authService.logout()">
            {{ 'header.logout' | translate }}
            <span class="icon icon-Logout"></span>
          </li>
          <li class="bottom-menu">
            <app-language-picker [isNameVisible]="false"></app-language-picker>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
